import PropTypes from "prop-types";
import { memo } from "react";

// Common Sections
import LongevityComponent from "@PayPlans/components/Commons/Longevity";
import TopPerformerBonus from "@PayPlans/components/Commons/TopPerformer";
import RetentionPayComponent from "@/PayPlans/components/Commons/RetentionPay";

// Customs
import FlagRateComponent from "@/PayPlans/components/Defaults/Technicians/FlagRate";
import FlaggedHoursComponent from "@/PayPlans/components/Defaults/Technicians/FlaggedHours";
import NightShiftPayComponent from "@/PayPlans/components/Defaults/Technicians/NightShiftPay";
import HolidayPayComponent from "@/PayPlans/components/Defaults/Technicians/HolidayPay";
import TargetedPerformanceBonusComponent from "@/PayPlans/components/Defaults/Technicians/TargetedPerformanceBonus";

function TargetedPerformanceBonusSection(props) {
	return <TargetedPerformanceBonusComponent {...props} />;
}
TargetedPerformanceBonusSection.propTypes = {
	sectionId: PropTypes.string,
	content: PropTypes.shape({
		tiers: PropTypes.array,
		applyTiersRetroactively: PropTypes.bool,
	}),
	loading: PropTypes.bool,
	readOnly: PropTypes.bool,
	onActionUpdate: PropTypes.func,
	useSectionsErrors: PropTypes.func,
};

function NightShiftPaySection(props) {
	return <NightShiftPayComponent {...props} />;
}
NightShiftPaySection.propTypes = {
	sectionId: PropTypes.string,
	content: PropTypes.shape({
		from: PropTypes.string,
		to: PropTypes.string,
		commission: PropTypes.shape({
			input: PropTypes.string,
			value: PropTypes.number,
		}),
		prorateByTimeCard: PropTypes.bool,
		isMultipleDays: PropTypes.bool,
		daysSelected: PropTypes.array,
		offset: PropTypes.number,
	}),
	loading: PropTypes.bool,
	readOnly: PropTypes.bool,
	useSectionsErrors: PropTypes.func,
	onActionUpdate: PropTypes.func,
};

function FlaggedHoursSection(props) {
	return <FlaggedHoursComponent {...props} />;
}
FlaggedHoursSection.propTypes = {
	sectionId: PropTypes.string,
	content: PropTypes.shape({
		tiers: PropTypes.array,
		applyTiersRetroactively: PropTypes.bool,
	}),
	loading: PropTypes.bool,
	readOnly: PropTypes.bool,
	onActionUpdate: PropTypes.func,
	useSectionsErrors: PropTypes.func,
};

const FlagRateSection = (props) => <FlagRateComponent {...props} />;
FlagRateSection.propTypes = {
	sectionId: PropTypes.string,
	position: PropTypes.string,
	content: PropTypes.shape({
		defaultValue: PropTypes.shape({
			input: PropTypes.string,
			value: PropTypes.number,
		}),
		isGuaranteedDraw: PropTypes.bool,
	}),
	disabled: PropTypes.bool,
	loading: PropTypes.bool,
	readOnly: PropTypes.bool,
	useSectionsErrors: PropTypes.func,
	onActionUpdate: PropTypes.func,
};

function HolidayPaySection(props) {
	return <HolidayPayComponent {...props} />;
}
HolidayPaySection.propTypes = {
	sectionId: PropTypes.string,
	content: PropTypes.object,
	useSectionsErrors: PropTypes.func,
	loading: PropTypes.bool,
	readOnly: PropTypes.bool,
	onActionUpdate: PropTypes.func,
};

function RetentionPaySection(props) {
	return <RetentionPayComponent {...props} />;
}
RetentionPaySection.propTypes = {
	sectionId: PropTypes.string,
	content: PropTypes.shape({
		retention: PropTypes.shape({
			input: PropTypes.string,
			value: PropTypes.number,
		}),
	}),
	loading: PropTypes.bool,
	readOnly: PropTypes.bool,
	useSectionsErrors: PropTypes.func,
	onActionUpdate: PropTypes.func,
};
function LongevitySection(props) {
	return <LongevityComponent {...props} />;
}
LongevitySection.propTypes = {
	sectionId: PropTypes.string,
	content: PropTypes.array,
	loading: PropTypes.bool,
	readOnly: PropTypes.bool,
	onActionUpdate: PropTypes.func,
	useSectionsErrors: PropTypes.func,
};

const TopTechniciansBonusSection = (props) => <TopPerformerBonus {...props} sectionId={"topTechniciansBonus"} />;
TopTechniciansBonusSection.propTypes = {
	sectionId: PropTypes.string,
	content: PropTypes.array,
	loading: PropTypes.bool,
	readOnly: PropTypes.bool,
	onActionUpdate: PropTypes.func,
	useSectionsErrors: PropTypes.func,
};

const DefaultPay = memo(FlagRateSection);
const FlaggedHoursBonus = memo(FlaggedHoursSection);
const NightShiftPay = memo(NightShiftPaySection);
const HolidayPay = memo(HolidayPaySection);
const RetentionPay = memo(RetentionPaySection);
const Longevity = memo(LongevitySection);
const TopTechniciansBonus = memo(TopTechniciansBonusSection);
const TargetedPerformanceBonus = memo(TargetedPerformanceBonusSection);

export { NightShiftPay, HolidayPay, RetentionPay, DefaultPay, Longevity, FlaggedHoursBonus, TopTechniciansBonus, TargetedPerformanceBonus };
